export const IDENTITY_CONFIG = {
  stsAuthority: process.env.REACT_APP_STS_AUTHORITY,
  clientId: 'DashboardV2', //(string): Your client application's identifier as registered with the OIDC provider.
  clientSecret: 'DarudeSandstorm',
  clientRoot: process.env.REACT_APP_ID_BASE_URL,
  clientScope: 'openid profile email roles', //(string, default: 'openid'): The scope being requested from the OIDC provider.
}
